<template>
  <div @click="$emit('closeLabel')" :class="['help-div' ,position]">
    <div class="description">{{text}}</div>
  </div>
</template>
<script>
export default {
  props: {
    text: String,
    position:String
  },
  data() {
    return {};
  },
  computed: {},
  methods: {}
};
</script>

<style lang="scss" scoped>
.help-div {
    min-width: 150px;
    width: auto;
    max-width: 200px;
    white-space: normal;
    position: absolute;
    border-radius: 4px;
    box-sizing: border-box;
    padding: 5px;
    box-shadow: 0 2px 5px 0 rgba(0,0,0,.26);
    z-index: 9999;
    background-color: #666666;
}
.right {
    top:0;
    left:30px;
}
.under-right {
    top:20px;
    left:0;
}
.under-left {
    top:20px;
    right:0;
}
.left{
    top:0;
    right:20px;
}
.up-left {
    bottom: 20px;
    right: 0;
}
.up-right {
    bottom: 20px;
    left: 0;
}
.help-div .description {
  color: white;
  font-size: 12px;
}
</style>
